import { motion } from "framer-motion";
import {
  Target, Cpu, Store, Wifi, Move, Sparkles, Award, Headphones, Handshake,
} from "lucide-react";
import { fadeUp, stagger, viewportOnceSmall } from "@/utils/motionVariants";

// Icons map positionally onto the 9 standard at-a-glance fields
// (best for, device type, environment, connectivity, mobility, smart
// features, key strength, support, CanDo fit).
const FIELD_ICONS = [Target, Cpu, Store, Wifi, Move, Sparkles, Award, Headphones, Handshake];

/**
 * Reusable at-a-glance summary grid. Stacks to a single column on mobile,
 * 3-up from md. Values kept short in the data file to avoid card overflow.
 */
export default function ProductAtAGlance({ product }) {
  return (
    <section className="py-16 md:py-20 bg-gray-50" data-testid={`${product.slug}-at-a-glance`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-heading text-2xl sm:text-3xl font-bold text-brand-black tracking-tight mb-8 text-center">
          {`${product.name} at a glance`}
        </h2>
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnceSmall}
          variants={stagger}
          className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4"
        >
          {product.atAGlance.map((field, i) => {
            const Icon = FIELD_ICONS[i % FIELD_ICONS.length];
            return (
              <motion.div
                key={field.label}
                variants={fadeUp}
                className="bg-white border border-brand-light-grey rounded-2xl p-5 flex items-start gap-4"
              >
                <div className="w-9 h-9 rounded-xl bg-brand-aqua-light flex items-center justify-center flex-shrink-0">
                  <Icon size={17} className="text-brand-aqua" aria-hidden="true" />
                </div>
                <div className="min-w-0">
                  <p className="text-xs font-bold uppercase tracking-wider text-brand-grey mb-1">{field.label}</p>
                  <p className="text-sm font-semibold text-brand-black leading-snug">{field.value}</p>
                </div>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
